export default __webpack_public_path__ + "static/media/explore.66640914.gif";